import { useQueryClient } from '@tanstack/react-query';
import { http } from 'services/http';
import { ADDITIONAL_COSTS_GET_MANY } from 'api/query-keys';
import { useMutationBase } from 'shared/hooks/use-mutation-base';

interface IUseDeleteAdditionalCostParams {
  orderId?: number;
  tripId?: number;
}

export const useDeleteAdditionalCost = (params: IUseDeleteAdditionalCostParams) => {
  const queryClient = useQueryClient();

  const { orderId, tripId } = params;

  const queryKey: string[] = [ADDITIONAL_COSTS_GET_MANY];
  if (orderId) {
    queryKey.push(String(orderId));
  } else if (tripId) {
    queryKey.push(String(tripId));
  }

  return useMutationBase<unknown, unknown, number>({
    mutationFn: async (id) => {
      const res = await http.delete(`/v1/additional-costs/${id}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });
};
